import { Routes } from '@angular/router';
import { keycloakGuard } from '@core-guards';
import { Path } from '@shared-enums';

export const routes: Routes = [
  {
    path: Path.Blank,
    loadComponent: () =>
      import('./core/components/side-navigation/side-navigation.component').then(
        c => c.SideNavigationComponent,
      ),
    canActivate: [keycloakGuard],
    children: [
      {
        path: Path.Blank,
        loadComponent: () =>
          import('./features/reservations/pages').then(c => c.ReservationsComponent),
      },
      {
        path: Path.NewReservation,
        loadComponent: () =>
          import(
            './features/new-reservation/pages/new-reservation/new-reservation.component'
          ).then(c => c.NewReservationComponent),
      },
      {
        path: Path.GpsLink,
        loadComponent: () =>
          import('./features/gps-link/pages/gps-link/gps-link.component').then(
            c => c.GpsLinkComponent,
          ),
      },
      {
        path: Path.AllReservations,
        loadComponent: () =>
          import('./features/reservations/pages').then(c => c.ReservationsComponent),
      },
      {
        path: `${Path.AllReservations}/:id`,
        loadComponent: () =>
          import(
            // eslint-disable-next-line max-len
            './features/reservations/components/preview-reservation/preview-reservation.component'
          ).then(c => c.PreviewReservationComponent),
      },
      {
        path: Path.AllWarehouses,
        loadComponent: () =>
          import('./features/warehouse/pages').then(c => c.WarehouseComponent),
      },
      {
        path: Path.DailyReports,
        loadComponent: () =>
          import('./features/daily-reports/pages').then(c => c.DailyReportsComponent),
      },
    ],
  },
  {
    path: Path.WildCard,
    redirectTo: Path.Root,
    pathMatch: 'full',
  },
];
